import { FC } from 'react'

import { ISvgClass } from '../interface'

const PDFIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M22.5 13.5V12H18V19.5H19.5V16.5H21.75V15H19.5V13.5H22.5ZM14.25 19.5H11.25V12H14.25C14.8466 12.0006 15.4185 12.2378 15.8403 12.6597C16.2622 13.0815 16.4994 13.6534 16.5 14.25V17.25C16.4994 17.8466 16.2622 18.4185 15.8403 18.8403C15.4185 19.2622 14.8466 19.4994 14.25 19.5ZM12.75 18H14.25C14.4489 17.9998 14.6395 17.9207 14.7801 17.7801C14.9207 17.6395 14.9998 17.4489 15 17.25V14.25C14.9998 14.0511 14.9207 13.8605 14.7801 13.7199C14.6395 13.5793 14.4489 13.5002 14.25 13.5H12.75V18ZM8.25 12H4.5V19.5H6V17.25H8.25C8.64764 17.2494 9.02883 17.0912 9.31 16.81C9.59118 16.5288 9.7494 16.1476 9.75 15.75V13.5C9.7496 13.1023 9.59144 12.721 9.31022 12.4398C9.029 12.1586 8.6477 12.0004 8.25 12ZM6 15.75V13.5H8.25L8.25075 15.75H6Z"
        fill="black"
      />
      <path
        d="M16.5 10.5V7.50001C16.5026 7.40144 16.4839 7.30347 16.4451 7.21284C16.4062 7.12221 16.3482 7.04107 16.275 6.97501L11.025 1.72501C10.959 1.65177 10.8778 1.59372 10.7872 1.55488C10.6966 1.51603 10.5986 1.49731 10.5 1.50001H3C2.60254 1.5012 2.2217 1.65961 1.94065 1.94066C1.6596 2.22171 1.50119 2.60255 1.5 3.00001V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H15V21H3V3.00001H9V7.50001C9.00119 7.89747 9.1596 8.27831 9.44065 8.55936C9.7217 8.84041 10.1025 8.99882 10.5 9.00001H15V10.5H16.5ZM10.5 7.50001V3.30001L14.7 7.50001H10.5Z"
        fill="inherit"
      />
    </svg>
  )
}

export default PDFIcon
